import $axios from "./index"

export function getProfile() {
    return $axios({
        url: `/profile/detail/`,
        method:"get"
    })
}


// 下载译员文件
export function downloadTranslatorFile(translator_id, fileType, fileId) {
    return $axios({
        url: `/profile/download/${translator_id}/?file_type=${fileType}&file_id=${fileId}`,
        method:"get",
        responseType: 'blob'
    })
}


// 获取翻译任务列表
export function getJobList(offset, quest_type, limit=20, acceptance_status="to_be_accepted") {
    return $axios({
        url: `/quests/list/?acceptance_status=${acceptance_status}&quest_type=${quest_type}&limit=${limit}&offset=${offset*limit}`,
        method:"get"
    })
}


// 接受或者拒绝任务
export function changeJobStatus(quests_id, jobType, status){
    let data = new FormData();
    data.append("quest_type", jobType);
    data.append("acceptance_status", status);
    return $axios({
        url: `/quests/state/${quests_id}/`,
        method:"put",
        data:data
    })
}

// 下载任务文件
export function downloadJobFile(jobId, downloadType, downloadFileType) {
    let url = `/quests/download/${jobId}/?quest_type=${downloadType}`;
    if(downloadFileType){
        url += `&file_type=${downloadFileType}`
    }
    return $axios({
        url: url,
        method:'get',
        responseType: 'blob'
    })
}


// 提交任务
export function submitJob(jobID, formData, fileList) {
    let data = new FormData();
    let queryArray = []
    for(let key in formData){
        if(formData[key]){
            queryArray.push(key)
        }
    }
    queryArray.forEach(item=>{
        if(item!='submit_files'&&item!='review_trans_file_data')
        data.append(item, formData[item])
    })
    let reviewTransFileData = []
    if(formData.quests_type == 'review'){
        for(let file in fileList){
            if(Object.prototype.toString.call(fileList[file]) == '[object Array]'){
                fileList[file].forEach(item=>{
                    data.append("submit_files", item.file)
                    reviewTransFileData.push({file_name: item.name, quest_id: item.taskId})
                })
            }
        }
        data.append("review_trans_file_data", JSON.stringify(reviewTransFileData))
    }else {
        formData.submit_files.forEach(item=>{
            data.append("submit_files", item.file)
            reviewTransFileData.push({file_name: item.name, quest_id: item.taskId})
        })
    }

    return $axios({
        url: `/quests/submit/${jobID}/`,
        method:"post",
        data: data
    })
}

// 查看任务记录
export function jobRecord(offset, record, limit=20) {
    return $axios({
        url: `/quests/record/?limit=${limit}&offset=${limit*offset}&quest_type=${record}`,
        method:"get",
    })
}



// 获取任务详情
export function jobDetail(jobType, jobId) {
    return $axios({
        url: `/quests/detail/${jobType}/${jobId}/`,
        method: 'get'
    })
}


// 审校任务上传时获取译员任务信息
export function getUploadReviewFileTaskInfo(jobId) {
    return $axios({
        url: `/quests/submit/${jobId}/`,
        method: 'get'
    })
}


// 重新申请测试
export function changeReTest() {
    return $axios({
        url: `/profile/apply/`,
        method: 'put'
    })
}